import { atom, selector } from 'recoil';

const SELECTED_SITE_KEY = 'sf_selected_site';

// Persist selected site to localStorage
const localStorageEffect = (key) => ({ setSelf, onSet }) => {
  const savedValue = localStorage.getItem(key);
  if (savedValue != null) {
    setSelf(savedValue);
  }
  onSet((newValue, _, isReset) => {
    isReset
      ? localStorage.removeItem(key)
      : localStorage.setItem(key, newValue);
  });
};

// Currently selected site for filtering data
export const selectedSiteAtom = atom({
  key: 'selectedSite',
  default: 'all',
  effects: [localStorageEffect(SELECTED_SITE_KEY)],
});

// List of all sites
export const sitesListAtom = atom({
  key: 'sitesList',
  default: [],
});

// Loading state for sites
export const sitesLoadingAtom = atom({
  key: 'sitesLoading',
  default: false,
});

// Error state for sites
export const sitesErrorAtom = atom({
  key: 'sitesError',
  default: null,
});

// Selector to get sites with "All Sites" option prepended
export const sitesWithAllSelector = selector({
  key: 'sitesWithAll',
  get: ({ get }) => {
    const sites = get(sitesListAtom);
    return [
      { site_id: 'all', site_name: 'All Sites', site_uuid: null },
      ...sites,
    ];
  },
});

// Selector to get currently selected site object
export const selectedSiteDataSelector = selector({
  key: 'selectedSiteData',
  get: ({ get }) => {
    const selectedId = get(selectedSiteAtom);
    const sites = get(sitesListAtom);

    if (selectedId === 'all') {
      return { site_id: 'all', site_name: 'All Sites' };
    }

    return sites.find(s => s.site_id === parseInt(selectedId)) || null;
  },
});
